import { render } from "./New.vue?vue&type=template&id=35831932"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"

import "./New.vue?vue&type=style&index=0&id=35831932&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__